import { OPTIN_CODES } from "../constants/OptinCodes"
import { loc } from "../core/utils"
import { TunnelDataContext } from "../digital-journey/context/TunnelDataContext"
import { getOfferFileTemplates } from "../service/OfferService"
import { CheckBoxOptin, RadioOptin } from "./Optin"
import { REQUIRED_MESSAGE } from "./defaultMessages"
import React from "react"
import { useContext } from "react"
import { Row } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"
import { useQuery } from "react-query"

export default function OptinPrivacyPR({ optin, hidden, tenant }) {
  const { tunnelData } = useContext(TunnelDataContext)
  const { code, label, type, required } = optin

  const { data: privacyConfirmationFileTemplate, isLoading: isLoadingFile } = useQuery({
    queryKey: ["get-privacy-confirmation-file"],
    queryFn: () => getOfferFileTemplates(tunnelData),
    enabled: code === OPTIN_CODES.SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT,
    refetchOnWindowFocus: false
  })

  const validate = (value) => {
    if (required && (value === undefined || value === "" || value === false)) {
      return loc(REQUIRED_MESSAGE)
    }
  }

  if (hidden) return null
  if (isLoadingFile || !privacyConfirmationFileTemplate || privacyConfirmationFileTemplate.length == 0) return null

  const fileTemplate = privacyConfirmationFileTemplate[0]

  return (
    <FinalFormField name={code} component="input" className="form-control" validate={validate} type={type} id={code}>
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched

        return (
          <Row className={`optin ${code.toLowerCase()} mr-0 ml-0 mt-8 mb-8 justify-content-between`}>
            {type.toLowerCase() === "checkbox" ? (
              <CheckBoxOptin
                input={input}
                label={loc(code, {
                  link: fileTemplate?.path,
                  tunnelData
                })}
                metaError={metaError}
                meta={meta}
              />
            ) : (
              <RadioOptin input={input} label={label} metaError={metaError} meta={meta} />
            )}
          </Row>
        )
      }}
    </FinalFormField>
  )
}
